import { render, staticRenderFns } from "./SetCurrency.vue?vue&type=template&id=223ec731"
import script from "./SetCurrency.vue?vue&type=script&lang=js"
export * from "./SetCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports